











import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'

interface Data {
  show: boolean
}

interface Methods {}

interface Computed {}

interface Props {
  options: any[]
  value: string | number,
  optionsViewCustomClass: string
}

export default Vue.extend({
  name: 'UiDropdown',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
      default: () => ''
    },
    optionsViewCustomClass: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      show: false
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
